module.exports = {
	HANDSHAKE_MESSAGE_NAME: '___handshake___',
	MESSAGE_EVENT_NAME: 'message'
};


// WEBPACK FOOTER //
// ./lib/consts.js